import React from "react";
import { Plus, Trash2, Pencil } from "lucide-react";
import { formatCurrency } from "@/lib/format";
import { Field } from "./StepBasics";

const dayBefore = (iso) => { const d = new Date(`${iso}T00:00:00Z`); d.setUTCDate(d.getUTCDate() - 1); return d.toISOString().slice(0, 10); };
const cost = (p, ck) => Object.values(p.classes?.[ck]?.items || {}).reduce((s, v) => s + Number(v.rate || 0), 0);

function changes(prev, p, cfg) {
  if (!prev) return [];
  const out = [];
  cfg.classes.forEach((c) => cfg.items.forEach((it) => {
    const a = prev.classes?.[c.key]?.items?.[it.key] || {}; const z = p.classes?.[c.key]?.items?.[it.key] || {};
    if (Number(a.qty || 0) !== Number(z.qty || 0) || Number(a.rate || 0) !== Number(z.rate || 0)) out.push(`${c.name}: ${it.emoji} ${it.name} ${Number(a.rate || 0)} → ${Number(z.rate || 0)}`);
  }));
  return out;
}

export default function StepReview({ cfg, set, b, setPi, goto }) {
  const upd = (i, patch) => set((c) => ({ ...c, periods: c.periods.map((p, j) => (j === i ? { ...p, ...patch } : p)) }));
  const add = () => set((c) => {
    const last = c.periods[c.periods.length - 1];
    const today = new Date().toISOString().slice(0, 10);
    const from = last.effective_from < today ? today : `${Number(last.effective_from.slice(0, 4)) + 1}${last.effective_from.slice(4)}`;
    const periods = c.periods.map((p, i) => (i === c.periods.length - 1 && !p.effective_to ? { ...p, effective_to: dayBefore(from) } : p));
    return { ...c, periods: [...periods, { ...JSON.parse(JSON.stringify(last)), name: `Rates from ${from}`, effective_from: from, effective_to: null }] };
  });
  return (
    <div className="space-y-4" data-testid="step-review">
      {cfg.periods.map((p, i) => {
        const ch = changes(cfg.periods[i - 1], p, cfg);
        const ab = cfg.items.find((x) => x.key === p.auto_balance_item);
        return (
          <div key={i} className="rounded-2xl bg-white border border-thali-turmeric/30 p-3 space-y-3" data-testid={`b-review-${i}`}>
            <div className="flex gap-2 items-end">
              <div className="flex-1"><Field label={b("period_name")}><input className="input-thali" value={p.name || ""} maxLength={60} onChange={(e) => upd(i, { name: e.target.value })} data-testid={`b-period-name-${i}`} /></Field></div>
              {cfg.periods.length > 1 && <button onClick={() => set((c) => ({ ...c, periods: c.periods.filter((_, j) => j !== i) }))} className="w-12 h-12 rounded-xl text-red-600 hover:bg-red-50 grid place-items-center" aria-label={b("remove")} data-testid={`b-period-remove-${i}`}><Trash2 className="w-5 h-5" /></button>}
            </div>
            <div className="grid grid-cols-2 gap-2">
              <Field label={b("from")}><input type="date" className="input-thali" value={p.effective_from || ""} onChange={(e) => upd(i, { effective_from: e.target.value })} data-testid={`b-period-from-${i}`} /></Field>
              <Field label={b("to")}><input type="date" className="input-thali" value={p.effective_to || ""} onChange={(e) => upd(i, { effective_to: e.target.value || null })} data-testid={`b-period-to-${i}`} /></Field>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
              {cfg.classes.map((c) => {
                const t = p.classes?.[c.key]?.target_total;
                const prevCost = cfg.periods[i - 1] ? cost(cfg.periods[i - 1], c.key) : null;
                const diff = prevCost !== null && Math.abs(prevCost - cost(p, c.key)) > 0.0001;
                return (
                  <div key={c.key} className={`rounded-xl p-2 ${diff ? "bg-thali-saffron/15 ring-2 ring-thali-saffron/50" : "bg-thali-cream"}`} data-testid={`b-review-cost-${i}-${c.key}`}>
                    <div className="text-[11px] font-semibold truncate" style={{ color: c.color }}>{c.emoji} {c.name}</div>
                    <div className="font-num font-bold">{formatCurrency(ab && t ? Number(t) : cost(p, c.key))}</div>
                    <div className="text-[10px] text-thali-ink/50">{ab && t ? `⚖️ ${ab.name}` : b("cost_all_items")}</div>
                  </div>
                );
              })}
            </div>
            {ch.length > 0 && (
              <div className="text-xs bg-thali-saffron/10 rounded-lg p-2 space-y-0.5" data-testid={`b-review-changes-${i}`}>
                <div className="font-bold">{b("changed_values")} ({ch.length})</div>
                {ch.slice(0, 8).map((x) => <div key={x}>• {x}</div>)}
              </div>
            )}
            <button onClick={() => { setPi(i); goto(3); }} className="btn-ghost text-sm border border-thali-green/40 text-thali-green w-full" data-testid={`b-review-edit-${i}`}><Pencil className="w-4 h-4" /> {b("edit")}</button>
          </div>
        );
      })}
      {cfg.periods.length < 30 && <button onClick={add} className="btn-ghost w-full border-2 border-dashed border-thali-turmeric/50" data-testid="b-add-period"><Plus className="w-4 h-4" /> {b("add_period")}</button>}
    </div>
  );
}
